<template>
	<div id="pg2">
		<section  class="publicar-cursos">
			<img v-responsive.xl.lg src="@/assets/landing/capacitador/publicar/publicar curso 1680x1050.jpg"
				 class="section_img">
			<img v-responsive.md src="@/assets/landing/capacitador/publicar/publicar curso 1024x768.jpg"
				 class="section_img">
			<img v-responsive.xs.sm src="@/assets/landing/capacitador/publicar/publicar curso 768x1024.jpg"
				 class="section_img">
			<div class="hyper-link">
				<div :class="isMobile ? 'row justify-content-center' : ''" >
					<a href="/perfil/cursos" :class="isMobile ? 'btn b-orange w-70 float-left' :  'btn b-orange w-50 float-right'" v-if="isLogin">
						¡Comienza Ahora!
					</a>
					<a href="/registrar/capacitador" :class="isMobile ? 'btn b-orange w-70 float-left' :  'btn b-orange w-50 float-right'" v-else>
						¡Comienza Ahora!
					</a>
				</div>
			</div>
		</section>

	</div>
</template>

<script>
export default {
	name: "publicar-cursos",
	props:['isLogin'],
	data() {
		return {
			isMobile: this.$mobile(),
		}
	}
}
</script>

<style scoped lang="scss">
.section_img {
	width: 100%;
	z-index: 1;
}
/* Botones de entradas de estilos utilizados en páginas de descripción de películas.*/
.publicar-cursos{
	//display:inline-block;
	position:relative;
}

.publicar-cursos .hyper-link a{
	width: max-content;
	font-size: large;
}

.publicar-cursos .hyper-link{
	position: absolute;
	bottom: 15%;
	right: 21%;
	@media only screen and (min-width: 320px)  and (max-device-width: 581px)  {
		top: 76%;
		left: 5%;
		width: 90%;
	}
	@media only screen and (min-width: 768px) {
		bottom: 10%;
		right: 10%;
		width: 45%;
	}
	@media only screen and (min-width: 960px) {
		bottom: 15%;
		right: 10%;
	}
	@media only screen and (min-width: 1440px) {
		bottom: 21%;
		right: 17%;
		width: 25%;
	}
	@media only screen and (min-width: 2000px) {
		bottom: 15%;
		right: 21%;
	}
	@media only screen and (max-device-width: 480px) {
		bottom: 4%;
		right: 3%;
	}
	@media only screen and (device-width: 768px) {
		bottom: 15%;
		right: 21%;
	}
	/* different techniques for iPad screening */
	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
		bottom: 8%;
		right: 11%;
	}

	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
		/* For landscape layouts only */
		bottom: 15%;
		right: 21%;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/landing/capacitador/publicar-cursos.vue